import { useState } from 'react';

export function useBrowserLocation() {
  // Browser location used as the starting point for route optimization.
  const [coords, setCoords] = useState<GeolocationCoordinates | null>(null);

  // True while waiting for the browser to return the current location.
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);

  // True once the browser fails or denies access to location.
  const [locationFailed, setLocationFailed] = useState(false);

  const requestLocation = () => {
    // Browser does not support geolocation.
    if (!navigator.geolocation) {
      setCoords(null);
      setLocationFailed(true);
      return Promise.resolve(null);
    }

    setIsLoadingLocation(true);
    setLocationFailed(false);

    return new Promise<GeolocationCoordinates | null>((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCoords(position.coords);
          setIsLoadingLocation(false);

          resolve(position.coords);
        },
        () => {
          // Clear any previously cached coordinates.
          setCoords(null);
          setLocationFailed(true);
          setIsLoadingLocation(false);

          resolve(null);
        }
      );
    });
  };

  return {
    coords,
    isLoadingLocation,
    locationFailed,
    requestLocation,
  };
}
